import "./Company.css";
import {
  homepage_header,
  company_partner_clem,
  company_partner_coco,
} from "../../Imgs/images";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

function Company() {
  return (
    <>
      <Header />
      <section className="sp-intro">
        <picture className="sp-intro-bg-img">
          <source srcSet={homepage_header} />
          <img
            src={homepage_header}
            alt="Equipe SPEnseignement devant un camion"
          />
        </picture>
        <h1 className="sp-intro-title">Soudry Préventions et Équipements</h1>
        <p className="sp-intro-description">
          Soudry Préventions et Équipements s’engage à offrir une assistance
          technique et des formations qui sont en adéquation avec les exigences
          des organismes privés, publics et associatifs dans les métiers du BTP
          et de l'industrie.
        </p>
      </section>
      <section className="company-team">
        <h2 className="sp-section-title">Kévin Soudry</h2>
        <p className="sp-section-paragraph company-team-paragraph">
          SOUDRY Kevin, fondateur et gérant de SOUDRY Préventions et
          Équipements. Fort d’un parcours en mécanique générale industrielle,
          j’ai obtenu en 2013 une licence en sécurité des biens et des
          personnes, avec une spécialisation en gestion des risques en santé,
          sécurité et environnement (SSE) ainsi qu’en radioprotection, grâce à
          un cursus en alternance.
        </p>
        <p className="sp-section-paragraph company-team-paragraph">
          Mon expérience professionnelle a débuté dans le secteur de l'énergie,
          avant que je ne me dirige vers l'industrie du bâtiment en 2014. J'ai
          occupé divers postes, allant de technicien QHSE à responsable de parc
          interne. Cette évolution m’a permis de développer une expertise solide
          en matière de sécurité au travail, me conduisant à créer ma propre
          société de formation et de conseil dédiée à la sécurité au travail.
        </p>
        <p className="sp-section-paragraph company-team-paragraph">
          Aujourd'hui, je me spécialise dans les outils de coupe et la
          protection des travailleurs, tant dans le secteur du bâtiment que dans
          l'industrie. En parallèle de ma carrière professionnelle, je suis
          pompier volontaire depuis l'âge de 17 ans, une expérience qui a
          renforcé ma passion pour la sécurité et le bien-être des personnes.
        </p>
        <p className="sp-section-paragraph company-team-paragraph">
          Mes compétences clés incluent le management dans le domaine de la SSE,
          la gestion d'équipe, ainsi que la pédagogie pour adultes. Mon objectif
          est de transmettre mes connaissances et de garantir un environnement
          de travail sûr et serein pour tous.
        </p>
        <p className="sp-section-paragraph company-team-paragraph">
          Je serais ravi de partager mon expertise et de contribuer à la
          sécurité de vos équipes.
        </p>
      </section>
      <section className="company-partners">
        <h2 className="sp-section-title">Des partenaires de confiance</h2>
        <div className="company-partners-list">
          <div className="company-partner">
            <div className="company-partner-img">
              <picture>
                <source srcSet={company_partner_clem} />
                <img src={company_partner_clem} alt="" />
              </picture>
            </div>
            <h4 className="company-partner-name">Clem'</h4>
            <p className="company-partner-description">
              Création de l'UX/UI du site web. Concepteur de site internet au
              sein de l'équipe AgoraVita.
            </p>
            <a
              href="https://www.clement-verdier.com"
              target="_blank"
              rel="noreferrer"
              className="company-partner-link"
            >
              Voir les créations
            </a>
          </div>
          <div className="company-partner">
            <div className="company-partner-img">
              <picture>
                <source srcSet={company_partner_coco} />
                <img src={company_partner_coco} alt="" />
              </picture>
            </div>
            <h4 className="company-partner-name">Corentin Delaunay</h4>
            <p className="company-partner-description">
              Développeur FullStack Web JS/TS et d'applications Unity/C#.
            </p>
            {/* <a
              href="https://google.fr"
              target="_blank"
              rel="noreferrer"
              className="company-partner-link"
            >
              Lien vers le site internet
            </a> */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Company;
